import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './styles/index.css';

import GridButton from './tools/gridButton'
import EmptyGridButton from './tools/emptyGridButton'

const baseURL = (process.env.REACT_APP_BACK_SERVER || '').replace(/\/?$/, '/');

export default function PlaySound(props) {

    const [notation, setNotation] = useState([]);
    const [answer, setAnswer] = useState([]);
    const [common, setCommon] = useState([]);
    const [position, setPosition] = useState([]);

    let gridcomplete = [];

   
    let allPositions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];




    useEffect(() => {

        const fetchAll = () => {
            let data = {};
            data["type"] = props.type;


            axios.post(baseURL + 'api/getNotation', data)
                .then(res => {
                    setNotation(Object.values(res.data));
                }).then(res => {

                    axios.post(baseURL + 'api/getAns', data)
                        .then(res => {
                            setAnswer(Object.values(res.data));
                        }).then(res => {

                            axios.post(baseURL + 'api/getCommon', data)
                                .then(res => {
                                    setCommon(Object.values(res.data));
                                }).then(res => {

                                    axios.get(baseURL + 'api/getPosition')
                                        .then(res => {
                                            setPosition(Object.values(res.data));
                                        }).then(res => {
                                          //  console.log("all done");
                                        })
                                })
                        })
                })
        };


        fetchAll();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    /**
     * Returns a random integer between min (inclusive) and max (inclusive).
     * The value is no lower than min (or the next integer greater than min
     * if min isn't an integer) and no greater than max (or the next integer
     * lower than max if max isn't an integer).
     * Using Math.round() will give you a non-uniform distribution!
     */
    const getRandomInt = (min, max) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    //get a random answer based on a common combination
    const getCommonAnswer = (commonCombi) => {

        let availableAnswers = [];
        let randomIndex = 0;

        for (var i = 0; i < answer.length; i++) {
            if (commonCombi.testp1 === answer[i].p1 && commonCombi.testp2 === answer[i].p2) {
                if (answer[i].total === 4) {
                    if (commonCombi.testp3 === answer[i].p3) //for combinations of 4 notations
                        availableAnswers.push(answer[i]);

                } else {
                    availableAnswers.push(answer[i]);//for combinations of 3 notations
                }
            }
        }
        //pick one answer from the list of availabile answers using a random index 
        randomIndex = getRandomInt(0, availableAnswers.length - 1);

        return availableAnswers[randomIndex];

    }

    const getCommon = () => {
        let availableCommon = [];
        let availableAnswers = [];
        let randomIndex = 0;


        //get a list of any 10 common combinations
        for (var i = 0; i < 5; i++) {
            randomIndex = getRandomInt(0, common.length - 1);
            availableCommon.push(common[randomIndex]);
        }

        //retrieve a random answer of each common combination
        for (var j = 0; j < availableCommon.length; j++) {
            let ans = getCommonAnswer(availableCommon[j]);
            if (ans) availableAnswers.push(ans);
        }

        return availableAnswers;
    }

    //get p1's position
    const getInitialPosition = () => {

        let usePosition = 0;

        let index = getRandomInt(0, allPositions.length - 1);

        usePosition = allPositions[index];
        allPositions.splice(index, 1);

        return usePosition;
    }

    //get a list of adjacent positions using the initial position
    const getAdjacentPosition = (initialPosition) => {

        let positions = [];
        for (var i = 0; i < position.length; i++) {
            if (position[i].position === initialPosition)
                positions.push(position[i].adjacentposition);
        }

        return positions;
    }

    const checkAdjacentPostionTaken = (gridaray, adjacentpositions) => {

        for (var i = 0; i < adjacentpositions.length; i++) {
            if (Object.keys(gridaray[adjacentpositions[i]]).length === 0)
                return adjacentpositions[i];
        }

        return 999; //cannot find any available positions
    }

    //remove position numbers which are used up by p2, p3 or p4
    const removePosition = (position) => {
        for (var i = 0; i < allPositions.length; i++) {
            if (allPositions[i] === position)
                allPositions.splice(i, 1);
        }
    }

    const assignNotationToGric = (gridarray, firstPosition, commonAnswerList) => {



        let adjacentPositions = [];
        let nextAvailablePosition = 0;
        if (!commonAnswerList || !commonAnswerList.p1) return gridarray;
        gridarray[firstPosition] = commonAnswerList.p1;

        //set position of p2
        adjacentPositions = getAdjacentPosition(firstPosition);

        nextAvailablePosition = checkAdjacentPostionTaken(gridarray, adjacentPositions);

        if (nextAvailablePosition !== 999) {
            gridarray[nextAvailablePosition] = commonAnswerList.p2;

            //remove position from allPositions array
            removePosition(nextAvailablePosition);

            //set position of p3
            adjacentPositions = getAdjacentPosition(nextAvailablePosition);
            nextAvailablePosition = checkAdjacentPostionTaken(gridarray, adjacentPositions);

            if (nextAvailablePosition !== 999) {
                gridarray[nextAvailablePosition] = commonAnswerList.p3;

                //remove position from allPositions array
                removePosition(nextAvailablePosition);

                if (commonAnswerList.p4 !== null) {
                    //set position of p4
                    adjacentPositions = getAdjacentPosition(nextAvailablePosition);
                    nextAvailablePosition = checkAdjacentPostionTaken(gridarray, adjacentPositions);

                    if (nextAvailablePosition !== 999) {
                        gridarray[nextAvailablePosition] = commonAnswerList.p4;

                        //remove position from allPositions array
                        removePosition(nextAvailablePosition);
                    }

                }
            }// if p3 is successfully assigned a postion
        }// if p2 is successfully assigned a postion

        return gridarray;
    }

    /* logic of generating this grid
    * selecting of grid position
    * 1. create an array that contains all grid positions: allpositions array
    * 2. at the getInitialPosition function, randomly pick a number from this allpositions array. the selected number will be passed to the next step
    * 3. removed from this allpositions array
    * 
    * generating answers
    * 1. at the getCommon function, randomly pick 5 common combinations from the full list of common combinations from the database 
    * 2. for each selected common combinations, pass them to the getCommonAnswer function to retrieve 5 randomly selected answers based on the common combinations
    * 3. pass the selected answers to the next step and name it as commonAnswerList array
    *
    * getting adjacent positions
    * 1. at the getAdjacentPosition function, using the initial position passed to it, find all possible adjacent positions and pass to an array adjacentPositions for the next step
    * 2. at the checkAdjacentPostionTaken function, it takes in a list of possible positions and check if they have been assigned. If one of the possible positions have been assigned, 
    * check the next possible position, until all possible positions have been checked. If found an empty position, return this position number. If all positions have been take up, return a 
    * '999' flag to tell the next step to stop the remaining steps (this '999' will not be used since we changed from getting 10 combis to 5 now)
    * 3. for grids which have not been filled up, the chords which have not been used will be used to fill those up
    *
    * assign notations to grid positions
    * 1. create an empty object to hold all 25 grid elements: gridarray array
    * 2. loop through the list of commonAnswerList array
    * 3. stop looping if all possibe positions have been taken up
    * 4. at the assignNotationToGric function, get the empty grids and assign them with p1, p2, p3 or p4 values
    * 5. remove positions used by p2 ,p3, p4 from the allpositions array
    * 6. as the gridarray is filling up, the number positions from the allpositions array will decrease
    */

    // all the above is to generate the gric======================================================================================




    const CreateGrid = () => {

        let gridarray = [];
        let leftOverNotation=[];
        let found = false;

        for (var i = 0; i < 25; i++) {
            gridarray[i] = "";

        }
        //console.log("creategrid")

        let initialPosition = 0;

        if(props.timerHasStopped === true) return <EmptyGridButton selectCombi={onSelectCombi}/>;

        //a list of answers
        let commonAnswerList = getCommon();


        for (var j = 0; j < commonAnswerList.length; j++) {
            if (allPositions.length >= 1) {
                initialPosition = getInitialPosition();
                gridarray = assignNotationToGric(gridarray, initialPosition, commonAnswerList[j]);

            }
        }


        //find out which are the notations which have not been used
        for (var notationkey in notation) {
            found = false;
            for (var b = 0; b < gridarray.length; b++) {
                if (gridarray[b] === notation[notationkey].code)
                found = true;
            }
            if(found === false)
                leftOverNotation.push(notation[notationkey].code);
        }
        

        for (var c = 0; c < gridarray.length; c++) {
            if(gridarray[c] === "")
            gridarray[c] = leftOverNotation[getRandomInt(0, leftOverNotation.length - 1)]; 
        }

      
       

        if (props.oldGrid.length > 0)  //when gridcomplete is passed from parent, do not reshuffle grid since this is only user submitted the combination
            gridcomplete = props.oldGrid;
        else {
            //use gridarray to make the complete grid data with other fields like superscript and subscript
            for (var a = 0; a < gridarray.length; a++) {
                for (var notationkey2 in notation) {
                    if (gridarray[a] === notation[notationkey2].code)
                        gridcomplete[a] = (notation[notationkey2]);
                }
            }
            
        }

       
      return <GridButton grid={gridcomplete} answer={answer} notation={notation} position={position} selectCombi={onSelectCombi} duration ={props.duration} chord={props.chord} volume={props.volume}/>




    };

    const onSelectCombi = (word, type) => {
        if (type === "reshuffle")
            selectResults("", "");
        if (type === "submitCombi")
            selectResults(word, gridcomplete)
        if (type === "restart")
            selectResults("", "", "restart")
        if (type === "newgame"){
            selectResults("", "", "newgame")
        }
    }



    const { selectResults } = props;



    return (
        <div>
            {position.length !== 0 && <CreateGrid />}
        </div>


    );
}